<template>
  <a :href="addresslink">{{address}}</a>
</template>

<script>
export default {
  name: 'EmailHider',
  props: ['sdom', 'pre', 'suf'],
  computed: {
    address() {
      return `${this.pre}@${this.sdom}${this.suf}`;
    },
    addresslink() {
      return `mailto:${this.address}`;
    }
  }
}
</script>


// WEBPACK FOOTER //
// EmailHider.vue?8190ac60